export default "__VITE_ASSET__fb606b9f__"